import { InjectionToken } from '@angular/core';
import { Config } from '@wdx/shared/utils';

export const APP_CONFIG = new InjectionToken<Config>('APP_CONFIG');
